module.exports = __webpack_public_path__ + "img/u5.d6dd83f4.svg";